var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dialog-end-game",class:_vm.content.bgColor},[_c('h1',{staticClass:"text-soft-cream"},[_vm._v(_vm._s(_vm.content.text))]),_c('app-button',_vm._b({attrs:{"variant":"rectangle"},on:{"click":function($event){return _vm.$modal.close()}}},'app-button',_vm.content.btnBind,false),[_vm._v(" Start the game again ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }